export default __webpack_public_path__ + "static/kubeproxy-2-0b8e5bba4059404db0bb30789813bcfe.png";